module.exports = __webpack_public_path__ + "img/successtransfer.0d72608e.svg";